// @flow
import SectionJobPlaces from './SectionJobPlaces';

export default SectionJobPlaces;
